var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.33332L10 7.99999H12C12 10.2067 10.2067 12 8 12C7.32667 12 6.68667 11.8333 6.13333 11.5333L5.16 12.5067C5.98 13.0267 6.95333 13.3333 8 13.3333C10.9467 13.3333 13.3333 10.9467 13.3333 7.99999H15.3333L12.6667 5.33332ZM4 7.99999C4 5.79332 5.79333 3.99999 8 3.99999C8.67333 3.99999 9.31333 4.16666 9.86667 4.46666L10.84 3.49332C10.02 2.97332 9.04667 2.66666 8 2.66666C5.05333 2.66666 2.66667 5.05332 2.66667 7.99999H0.666666L3.33333 10.6667L6 7.99999H4Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.8455d929bf1b9571d8ab0fd43b0e5864.svg";